import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_MOBILE_APP_COMBINED_DESKTOP_DOWNLOAD_BANNER_V2 = defineFcm(
	'mobile_app_combined_desktop_download_banner_v2',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				traffic_percentage: { type: 'number' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-mobile',
		scope: 'corgi-front-end',
		context: 'Starter Dashboard and Starter Petition Page',
		description:
			'Controls the rollout of the V2 combined iOS/Android desktop download banner on the starter dashboard and starter petition page(s).',
		template: {
			traffic_percentage: 0,
		},
	});
